import React, {Component} from 'react';

import {
    BrowserRouter as Router,   
    NavLink
  } from "react-router-dom";

import PersonMessages from './messages.component'

class BurgerMenu extends Component {


  state = {
    redirect : null,
    showModalBurgerMenu : false
  }

  onPaths = (paths) => {
    return (match, location) => {
      return paths.includes(location.pathname);
    };
  }

  setModalBurgerMenuClosed = () => {
    this.setState({ showModalBurgerMenu: false }); 
  }

  setModalBurgerMenuOpened = () => {
    console.log('setModalBurgerMenuOpened clecked!');
    this.setState({ showModalBurgerMenu: true }); 
  }

  render() { 
    return (
      <React.Fragment>

        {(this.state.showModalBurgerMenu) ?
   
            <div className="burgerScreenMenu">
              <div className="modal_filter_bg " ></div>
              <div className="hotels_list_filter_box">
                  <div className="close_arrow pointer zindex1000" 
                      onClick={ () => this.setModalBurgerMenuClosed() }></div>

                  <div className="filter_container">
                  
                      <div className="burger_inner_container">
                          <div className="hotel_details_rigth_title_padding">
                              <span className="filter_container_title1">תפריט אתר נופש </span>
                          </div>

                          <NavLink className="filter_container_title2 mobileMenuItem" activeClassName=" "
                              to="/" 
                              isActive={ this.onPaths(["/", "/results"])}  >
                              {<div className="" >ראשי</div>}
                          </NavLink>

                          <NavLink   className="filter_container_title2 mobileMenuItem" activeClassName=""   
                              to={"/orders"}>
                              {<div className="" >הזמנות שלי</div>}
                          </NavLink >
                  
                        <NavLink   className="filter_container_title2 mobileMenuItem" activeClassName=" "   
                            to={"/hotels"}>
                            {<div className="" >רשימת כל בתי המלון</div>}
                        </NavLink >

                        <NavLink   className="filter_container_title2 mobileMenuItem" activeClassName=""   
                            to={"/images/policy.pdf"} target="_blank">
                            {<div className="" >מדיניות</div>}
                        </NavLink >

                      </div>
                  </div>
              </div>
            
            </div>
        : null}





        <div className="pos-f-t  hp_uppermenu_burgerScreen" onClick={ () => this.setModalBurgerMenuOpened() }>
            <nav className="navbar navbar-dark ">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
                </button>
            </nav>
        </div>        
    </React.Fragment>
    )
  }
}

export default BurgerMenu;


